import clsx from 'clsx';
import { endOfDay } from 'date-fns';
import { zonedTimeToUtc } from 'date-fns-tz';
import { useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';
import { toTitleCase } from '../../../../../../_metronic/helpers';
import {
  FieldStatus,
  FrequencyType,
  ScheduleRequestStatus,
} from '../../../../../pages/siteIntelligence/mappings';
import MultiSelection from '../../components/MultiSelection';
import SearchInputGroup from '../../components/SearchInputGroup';
import SingleSelection from '../../components/SingleSelection';
import { useFilter } from '../../FilterContext';
import DatePickerFilter from '../components/DatePickerFilter';

export function ScheduleFilter() {
  const params = useParams();
  const intl = useIntl();
  const { globalFilter, setGlobalFilter } = useFilter();
  const filterKey = 'scheduleList';

  const frequencyOptions = Object.keys(FrequencyType)
    .filter((key) => key !== FrequencyType.NOW)
    .map((key) => ({
      value: key,
      label: toTitleCase(key.replaceAll('_', ' ')),
    }));

  const statusOptions = Object.keys(FieldStatus).map((key) => ({
    value: key,
    label: toTitleCase(key.replaceAll('_', ' ')),
  }));

  const requestStatusOptions = Object.keys(ScheduleRequestStatus).map((key) => ({
    value: key,
    label: toTitleCase(key.replaceAll('_', ' ')),
  }));

  return (
    <>
      <div className={clsx(params.id ? 'blur' : '')}>
        <div className='d-inline-flex flex-wrap'>
          {/* Select */}
          <div className='d-flex'>
            {/* Date Picker */}
            <DatePickerFilter
              onChange={(selectedDate) =>
                setGlobalFilter({
                  ...globalFilter,
                  [filterKey]: {
                    ...globalFilter?.[filterKey],
                    display_next_run_date: selectedDate && {
                      from: zonedTimeToUtc(new Date(selectedDate.start), 'Hongkong').toISOString(),
                      to: zonedTimeToUtc(
                        new Date(endOfDay(selectedDate.end)),
                        'Hongkong'
                      ).toISOString(),
                    },
                  },
                })
              }
              globalFilterValue={
                globalFilter?.[filterKey]?.display_next_run_date?.from &&
                globalFilter?.[filterKey]?.display_next_run_date?.to && {
                  startDate: new Date(globalFilter?.[filterKey]?.display_next_run_date?.from),
                  endDate: new Date(globalFilter?.[filterKey]?.display_next_run_date?.to),
                }
              }
              label='Next Scan Date'
              placeholder='Filter Next Scan Date'
              className='me-6'
            />

            {/* Service */}
            <MultiSelection
              title='Frequency'
              globalFilterValue={globalFilter?.[filterKey]?.frequency?.values}
              options={frequencyOptions}
              onChange={(e) => {
                setGlobalFilter({
                  ...globalFilter,
                  [filterKey]: {
                    ...globalFilter?.[filterKey],
                    frequency: { type: 'in', values: e },
                  },
                });
              }}
            />

            {/* Schedule Status */}
            <MultiSelection
              title='Schedule Status'
              globalFilterValue={globalFilter?.[filterKey]?.status?.values}
              options={statusOptions}
              onChange={(e) => {
                setGlobalFilter({
                  ...globalFilter,
                  [filterKey]: {
                    ...globalFilter?.[filterKey],
                    status: { type: 'in', values: e },
                  },
                });
              }}
            />

            {/* Request Status */}
            <MultiSelection
              title='Request Status'
              globalFilterValue={globalFilter?.[filterKey]?.request_status?.values}
              options={requestStatusOptions}
              onChange={(e) => {
                setGlobalFilter({
                  ...globalFilter,
                  [filterKey]: {
                    ...globalFilter?.[filterKey],
                    request_status: { type: 'in', values: e },
                  },
                });
              }}
            />
          </div>

          {/* Search */}
          <SearchInputGroup
            inputs={[
              {
                key: 'payload.url',
                title: 'URL',
                minWidth: 250,
              },
              {
                key: 'payload.request_info.merchant_name',
                title: 'Merchant Name',
                minWidth: 100,
              },
              {
                key: 'merchant_name',
                title: 'Client Name',
                minWidth: 100,
              },
              {
                key: 'merchant_id',
                title: 'Client ID',
                minWidth: 250,
              },
            ]}
            section={filterKey}
            globalFilterValue={globalFilter}
            onSubmit={(searchValues) =>
              setGlobalFilter({
                ...globalFilter,
                [filterKey]: { ...globalFilter?.[filterKey], ...searchValues },
              })
            }
            onClear={(searchValues) =>
              setGlobalFilter({
                ...globalFilter,
                [filterKey]: { ...globalFilter?.[filterKey], ...searchValues },
              })
            }
          />
        </div>
      </div>
    </>
  );
}
